module.exports = __webpack_public_path__ + "img/image@2x.79432670.webp";